import  * as ProfileActions from '../actions/ProfileActions'

export interface IProfileState {
    result: ProfileActions.IProfileType;
}

export interface IExportUserGdprReportState {
    result: ProfileActions.IExportUserGdprReportType;
}

export interface ICanExportGdprReportState {
    result: ProfileActions.ICanExportGdprReportType;
}

export interface IRequestUserYearInReviewReportState {
    result: ProfileActions.IRequestUserYearInReviewReportType;
}

export interface ICanRequestYearInReviewReportState {
    result: ProfileActions.ICanRequestYearInReviewReportType;
}

const initialProfileState : IProfileState = {
    result: {
        userName: "",
        registrationDate: new Date(),
        statistics: {
            timePlayedInTicks: 0,
            chartsPlayed: 0,
            totalTaps: 0,
            chartsWritten: 0,
            chartsRated: 0,
            maxDifficultyPassed: 0,
        },
        subscription: {
            status: -1,
            expirationDate: "",
        },
    }
}

const initialCanExportGdprReportState : ICanExportGdprReportState = {
    result: {
        requestTime: null,
    }
}

const initialExportUserGdprReportState : IExportUserGdprReportState = {
    result: {
        nextRequestTime: new Date(9000, 0, 1),
    }
}

const initialCanRequestYearInReviewReportState : ICanRequestYearInReviewReportState = {
    result: {
        canRequest: false,
        acceptedYears: [],
    }
}

const initialRequestUserYearInReviewReportState : IRequestUserYearInReviewReportState = {
    result: {
        year: -1,
    }
}

export const getProfileReducer = (
    state: IProfileState = initialProfileState,
    action: any): IProfileState => {
    switch (action.type) {
        case ProfileActions.GET_PROFILE_SUCCEEDED_ACTION_TYPE:
            return {
                result: {
                    ...action.json
                },
            }
        default:
            return state;
    }
}

export const exportUserGdprReportReducer = (
    state: IExportUserGdprReportState = initialExportUserGdprReportState,
    action: any): IExportUserGdprReportState => {
    switch (action.type) {
        case ProfileActions.EXPORT_USER_GDPR_REPORT_SUCCEEDED_ACTION_TYPE:
            return {
                result: {
                    ...action.json
                },
            }
        default:
            return state;
    }
}

export const getUserCanExportGdprReportReducer = (
    state: ICanExportGdprReportState = initialCanExportGdprReportState,
    action: any): ICanExportGdprReportState => {
    switch (action.type) {
        case ProfileActions.GET_USER_CAN_EXPORT_GDPR_REPORT_SUCCEEDED_ACTION_TYPE:
            return {
                result: {
                    ...action.json
                },
            }
        case ProfileActions.GET_USER_CAN_EXPORT_GDPR_REPORT_FAILED_ACTION_TYPE:
            return {
                result: {
                    requestTime: null,
                }
            }
        default:
            return state;
    }
}

export const requestUserYearInReviewReportReducer = (
    state: IRequestUserYearInReviewReportState = initialRequestUserYearInReviewReportState,
    action: any): IRequestUserYearInReviewReportState => {
    switch (action.type) {
        case ProfileActions.REQUEST_USER_YEAR_IN_REVIEW_REPORT_ACTION_TYPE:
            return {
                result: {
                    ...action.json
                },
            }
        default:
            return state;
    }
}

export const getUserCanRequestYearInReviewReportReducer = (
    state: ICanRequestYearInReviewReportState = initialCanRequestYearInReviewReportState,
    action: any): ICanRequestYearInReviewReportState => {
    switch (action.type) {
        case ProfileActions.GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_SUCCEEDED_ACTION_TYPE:
            return {
                result: {
                    canRequest: action.json.exists,
                    acceptedYears: [...action.acceptedYears],
                },
            }
        case ProfileActions.GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE:
            return {
                result: {
                    canRequest: false,
                    acceptedYears: [],
                }
            }
        default:
            return state;
    }
}